import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './styles/addclass.css'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'
import Confirm from '../components/confirm'
import { IoMdClose } from "react-icons/io"
import PlayersComponent from '../components/playerscomponent'

//Extras
import { fontType, main } from '../assets/extras'
import { categorias, niveles } from '../assets/datas'
import { addDoc, arrayUnion, collection, doc, getDocs, query, setDoc, updateDoc, where } from 'firebase/firestore'
import { db } from '../assets/connections'
import { filterTeachersBySedes } from '../assets/classUtils'

const AddClass = () => {

    const navigate = useNavigate()
    
    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const academia = location.state ? location.state.academia : null
    const sedeId = location.state ? location.state.sedeId : ""
    const sedeNombre = location.state ? location.state.sedeNombre : ""

    const [ variables, setVariables ] = useState({
        loading: true,
        data: [],
        newClass: {
            nombre_clase: "",
            descripcion_clase: "",
            profesor_clase: "",
            nombre_profesor: "",
            profesor_clase_secundario: "",
            nombre_profesor_secundario: "",
            categoria: categorias[0],
            nivel: niveles[0],
            dias_clase: [],
            limite_jugadores: 0
        },
        titulo: "",
        isGroup: false,
        teacher: "",
        newPlayers: []
    })

    const [ showModal, setShowModal ] = useState(false)

    //Horas en formato de 24hrs con medias horas
    const hours = [
        "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30",
        "05:00", "05:30", "06:00", "06:30", "07:00", "07:30", "08:00", "08:30",
        "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30",
        "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30",
        "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00", "20:30",
        "21:00", "21:30", "22:00", "22:30", "23:00", "23:30", "24:00"
    ]

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Varibles para el uso del confirm
    const [ confirm, setConfirm ] = useState({
        show: false,
        title: "",
        text: ""
    })

    //Obtiene a los profesores de la bd
    const getData = async () => {
        // Cargar profesores
        await getDocs(query(collection(db, "Profesores"), where("academia_profesor", "array-contains", academia))).then(r => {
            if(r.docs.length > 0){
                var aux = []
                r.docs.map(v => {
                    aux.push(v.data())
                })
                setVariables(prev => ({
                    ...prev,
                    data: aux
                }))
            }
        }).catch(e => {
            console.log(e.code + " " + e.message)
        })

        setVariables(prev => ({
            ...prev,
            loading: false
        }))
    }

    //Funcion que valida los campos
    const validateFields = () => {
        var valid = true
        if(!variables.isGroup){
            if(!variables.titulo){
                valid = false
            }
        }
        if(valid && variables.newClass.descripcion_clase){
            if(variables.newClass.profesor_clase){
                if(variables.newClass.categoria){
                    if(variables.newClass.nivel){
                        if(variables.newClass.dias_clase.length > 0){
                            var cont = 0
                            for(let i = 0; i < variables.newClass.dias_clase.length; i++){
                                if(!variables.newClass.dias_clase[i].dia || !variables.newClass.dias_clase[i].de || !variables.newClass.dias_clase[i].a){
                                    cont ++
                                }
                            }
                            if(cont > 0){
                                showMessage("Debes completar los datos de los dias de la clase", "warning")
                            } else {
                                if(variables.newClass.limite_jugadores >= 0 && variables.newClass.limite_jugadores <= 12){
                                    if(variables.newClass.limite_jugadores == 0){
                                        setConfirm(prev => ({
                                            ...prev,
                                            show: true,
                                            title: "CREAR CLASE",
                                            text: "¿Estas seguro de crear una clase nueva?"
                                        }))
                                    } else {
                                        if(variables.newClass.limite_jugadores < variables.newPlayers.length){
                                            console.log(variables.newClass.limite_jugadores)
                                            console.log(variables.newPlayers.length)
                                            showMessage("El limite de jugadores debe de ser mayor o igual al numero de jugadores", "warning")
                                        } else {
                                            setConfirm(prev => ({
                                                ...prev,
                                                show: true,
                                                title: "CREAR CLASE",
                                                text: "¿Estas seguro de crear una clase nueva?"
                                            }))
                                        }
                                    }
                                } else {
                                    showMessage("Debes agregar un limite a la clase", "warning");
                                }
                            }
                        } else {
                            showMessage("Debes agregar al menos un dia para clase", "warning")
                        }
                    } else {
                        showMessage("Debes seleccionar un nivel de grupo", "warning")
                    }
                } else {
                    showMessage("Debes agregar una categoria de grupo", "warning")
                }
            } else {
                showMessage("Debes seleccionar un profesor", "warning")
            }
        } else {
            showMessage("Debes completar todos los campos", "warning")
        }
    }

    //Funcion que agrega a un jugador nuevo a la lista
    const addNewPlayer = ({id, nombre_jugador}) => {
        if(variables.newClass.limite_jugadores === 0){
            var cont = 0
            for(let i = 0; i < variables.newPlayers.length; i++){
                if(id == variables.newPlayers[i].id){
                    cont ++
                }
            }
            if(cont == 0){
                variables.newPlayers.push({
                    id,
                    nombre_jugador: nombre_jugador
                })
        
                setVariables(prev => ({
                    ...prev
                }))

                showMessage("Jugador agregado correctamente", "success")
            } else {
                showMessage("El jugador ya esta agregado en la lista", "warning")
            }
        } else {
            if((variables.newPlayers.length + 1) <= variables.newClass.limite_jugadores){
                var cont = 0
                for(let i = 0; i < variables.newPlayers.length; i++){
                    if(id == variables.newPlayers[i].id){
                        cont ++
                    }
                }
                if(cont == 0){
                    variables.newPlayers.push({
                        id,
                        nombre_jugador: nombre_jugador
                    })

                    setVariables(prev => ({
                        ...prev
                    }))
                } else {
                    showMessage("El jugador ya esta agregado en la lista", "warning")
                }
            } else {
                showMessage("Ya no hay espacio en la clase", "warning")
            }
        }
    }

    //Funciones que crean la clase
    const handleCreateClass = () => {
        setConfirm(prev => ({
            ...prev,
            show: false
        }))
        setVariables(prev => ({
            ...prev,
            loading: true
        }))
        creating()
    }
    const creating = async () => {
        await addDoc(collection(doc(db, ref), "Clases"), {
            ...variables.newClass,
            nombre_clase: variables.isGroup ? (variables.newClass.nivel + " / " + variables.newClass.categoria) : variables.titulo,
            isGroup: variables.isGroup,
            numero_jugadores: variables.newPlayers.length,
            clases_muestra: 0,
            sede: sedeId || "",
            nombre_sede: sedeNombre || ""
        }).then(r => {
            createHistoryClass(r.id)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }
    const createHistoryClass = async (id) => {
        await setDoc(doc(doc(db, ref), "Historial", id), {
            id
        }).then(r => {
            addingNewPlayers(id)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }
    const addingNewPlayers = async (id) => {
        var count = 0

        for(let i = 0; i < variables.newPlayers.length; i++){
            await updateDoc(doc(doc(db, ref), "Jugador", variables.newPlayers[i].id), {
                clases_jugador: arrayUnion(id)
            }).then(r => {
                count ++
            })
        }

        if(count === variables.newPlayers.length){
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Clase creada con exito", "success")
                setTimeout(() => {
                    window.history.back()
                }, 1000)
            }, 100)
        } else {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Clase creada. Algunos jugadores no se agregaron", "success")
                setTimeout(() => {
                    window.history.back()
                }, 1000)
            }, 100)
        }
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            getData()
        }
    }, [])

    if(variables.loading){
        return (
            <Loader loading={variables.loading} />
        )
    }

    if(!variables.loading)
    return (
        <div className='mainAddClass'>

            <Snack />

            <Confirm
                confirm={confirm}
                setConfirm={setConfirm}
                onHandle={handleCreateClass}
            />

            {
                showModal === true ?
                    <PlayersComponent
                        reference={ref}
                        addPlayer={addNewPlayer}
                        showModal={showModal}
                        setShowModal={setShowModal}
                    />
                : null
            }

            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.title,
                paddingBottom: 0
            }}>AGREGAR CLASE</h2>
            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.text,
                marginTop: -50,
                marginBottom: 40,
                fontSize: 18,
                padding: 10,
                paddingBottom: 20,
                paddingTop: 0
            }}>{
                localStorage.getItem("authToken") ? 
                    JSON.parse(localStorage.getItem("authToken")).nombre_academia
                : ""
            }</h2>

            <div className='contInfoClass'>

                <div className='infoClass'>

                    <div className='info-item'>
                        <p style={{
                            fontFamily: fontType.text
                        }}>Nombre de la clase</p>
                        <input
                            style={{
                                borderColor: "#DDD",
                                fontFamily: fontType.text
                            }}

                            value={variables.isGroup ? (variables.newClass.nivel + " / " + variables.newClass.categoria) : variables.titulo}
                            maxLength={25}
                            onChange={e => {
                                const t = e.target.value

                                setVariables(prev => ({
                                    ...prev,
                                    titulo: t
                                })) 
                            }}
                            disabled={variables.isGroup}
                        />
                    </div>

                    {sedeNombre && (
                        <div style={{ marginBottom: 30 }} className='info-item'>
                            <p style={{
                                fontFamily: fontType.text
                            }}>Sede</p>
                            <p style={{
                                fontFamily: fontType.text,
                                fontSize: 16,
                                padding: 10,
                                backgroundColor: "#f5f5f5",
                                borderRadius: 5,
                                border: "2px solid #DDD"
                            }}>{sedeNombre}</p>
                        </div>
                    )}

                    <div style={{ marginBottom: 30 }} className='info-item'>
                        <p style={{
                            fontFamily: fontType.text
                        }}>Descripcion de la clase</p>
                        <input
                            style={{
                                borderColor: "#DDD",
                                fontFamily: fontType.text
                            }}
                            value={variables.newClass.descripcion_clase}
                            maxLength={200}
                            onChange={e => {
                                const t = e.target.value

                                setVariables(prev => ({
                                    ...prev,
                                    newClass: {
                                        ...prev.newClass,
                                        descripcion_clase: t
                                    }
                                }))
                            }}
                        />
                    </div>

                    <div className='checkbox-cont'>
                        <input type="checkbox" id="check1" checked={variables.isGroup} onChange={() => {
                            setVariables(prev => ({
                                ...prev,
                                isGroup: !variables.isGroup
                            }))
                        }} /><label for="check1" style={{
                            fontFamily: fontType.text
                        }}>Clase grupal</label>
                    </div>

                    <div className='contData' style={{
                        border: "2px solid " + main
                    }}>

                        <div className='contSelect'>
                            <p style={{
                                fontFamily: fontType.text,
                                fontWeight: "bolder",
                                marginBottom: 8
                            }}>Seleccionar profesor: {variables.teacher}</p>
                            <div className='custom-select'>

                                <select id="Profesor" name="Profesor" style={{
                                    fontFamily: fontType.text
                                }}
                                    onChange={e => {
                                        const t = JSON.parse(e.target.value)

                                        setVariables(prev => ({
                                            ...prev,
                                            teacher: t.nombre,
                                            newClass: {
                                                ...prev.newClass,
                                                profesor_clase: t.correo,
                                                nombre_profesor: t.nombre
                                            }
                                        }))

                                    }}
                                >
                                    <option value={""}>...</option>
                                    {
                                        filterTeachersBySedes(variables.data, academia, [sedeId]).map((v, i) => {
                                            return (
                                                <option key={i} value={
                                                    JSON.stringify({ correo: v.correo_profesor, nombre: v.nombre_profesor + " " + v.apellido_p_profesor })
                                                }>{v.nombre_profesor + " " + v.apellido_p_profesor}</option>
                                            )
                                        })
                                    }
                                </select>

                            </div>
                        </div>

                        <div className='contSelect'>
                            <p style={{
                                fontFamily: fontType.text,
                                fontWeight: "bolder",
                                marginBottom: 8
                            }}>Profesor secundario (opcional)</p>
                            <div className='custom-select'>

                                <select id="ProfesorSecundario" name="ProfesorSecundario" style={{
                                    fontFamily: fontType.text
                                }}
                                    onChange={e => {
                                        const t = e.target.value ? JSON.parse(e.target.value) : null

                                        setVariables(prev => ({
                                            ...prev,
                                            newClass: {
                                                ...prev.newClass,
                                                profesor_clase_secundario: t ? t.correo : "",
                                                nombre_profesor_secundario: t ? t.nombre : ""
                                            }
                                        }))

                                    }}
                                >
                                    <option value="">Sin profesor secundario</option>
                                    {
                                        filterTeachersBySedes(variables.data, academia, [sedeId]).map((v, i) => {
                                            return (
                                                <option key={i} value={
                                                    JSON.stringify({ correo: v.correo_profesor, nombre: v.nombre_profesor + " " + v.apellido_p_profesor })
                                                }>{v.nombre_profesor + " " + v.apellido_p_profesor}</option>
                                            )
                                        })
                                    }
                                </select>

                            </div>
                        </div>

                        <div className='contSelect'>
                            <p style={{
                                fontFamily: fontType.text,
                                fontWeight: "bolder",
                                marginBottom: 8
                            }}>Categoria</p>
                            <div className='custom-select'>
                                <select id="Categoria" name="Categoria" style={{
                                    fontFamily: fontType.text
                                }}
                                    value={variables.newClass.categoria}
                                    onChange={e => {
                                        const t = e.target.value
                                        setVariables(prev => ({
                                            ...prev,
                                            newClass: {
                                                ...prev.newClass,
                                                categoria: t,
                                                nombre_clase: prev.newClass.nivel + " / " + t
                                            }
                                        }))
                                    }}
                                >
                                    {
                                        categorias.map(v => {
                                            return (
                                                <option value={v}>{v}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className='contSelect'>
                            <p style={{
                                fontFamily: fontType.text,
                                fontWeight: "bolder",
                                marginBottom: 8
                            }}>Nivel</p>
                            <div className='custom-select'>
                                <select id="Nivel" name="Nivel" style={{
                                    fontFamily: fontType.text
                                }}
                                    value={variables.newClass.nivel}
                                    onChange={e => {
                                        const t = e.target.value
                                        setVariables(prev => ({
                                            ...prev,
                                            newClass: {
                                                ...prev.newClass,
                                                nivel: t,
                                                nombre_clase: t + " / " + prev.newClass.categoria
                                            }
                                        }))
                                    }}
                                >
                                    {
                                        niveles.map(v => {
                                            return (
                                                <option value={v}>{v}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className='contLimite'>
                            <p style={{
                                fontFamily: fontType.text,
                                fontWeight: "bolder",
                                marginBottom: 8
                            }}>Limite de jugadores</p>
                            <div className='custom-select'>

                                <select id="Limite" name="Limite" style={{
                                    fontFamily: fontType.text,
                                    width: "100%"
                                }}
                                    onChange={e => {
                                        const t = e.target.value

                                        setVariables(prev => ({
                                            ...prev,
                                            newClass: {
                                                ...prev.newClass,
                                                limite_jugadores: t
                                            }
                                        }))

                                    }}
                                >
                                    <option value={0}>Ninguno</option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                    <option value={6}>6</option>
                                    <option value={7}>7</option>
                                    <option value={8}>8</option>
                                    <option value={9}>9</option>
                                    <option value={10}>10</option>
                                    <option value={11}>11</option>
                                    <option value={12}>12</option>
                                </select>

                            </div>
                        </div>

                    </div>

                    <p style={{
                        fontFamily: fontType.title,
                        fontWeight: "bold",
                        fontSize: 25,
                        marginBottom: 10
                    }}>DIAS DE CLASE</p>

                    <div className='contDias'>
                        {
                            variables.newClass.dias_clase.map((v, i) => {
                                return (
                                    <div className='dia' key={i}>
                                        <div className='dia-out'>
                                            <IoMdClose id='outdia' size={20} color='#C00' onClick={() => {
                                                //Sacar dia
                                                variables.newClass.dias_clase.splice(i, 1)
                                                setVariables(prev => ({
                                                    ...prev
                                                }))
                                            }} />
                                        </div>

                                        <div className='dia-dia'>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold"
                                            }}>Dia de la clase:</p>
                                            <div className='custom-select'>
                                                <select id="Dia de la clase" name="Dia de la clase" style={{
                                                    fontFamily: fontType.text
                                                }}
                                                    value={variables.newClass.dias_clase[i].dia}
                                                    onChange={e => {
                                                        variables.newClass.dias_clase[i].dia = e.target.value
                                                        setVariables(prev => ({
                                                            ...prev
                                                        }))
                                                    }}
                                                >
                                                    <option value={""}>...</option>
                                                    <option value="Lunes">Lunes</option>
                                                    <option value="Martes">Martes</option>
                                                    <option value="Miercoles">Miercoles</option>
                                                    <option value="Jueves">Jueves</option>
                                                    <option value="Viernes">Viernes</option>
                                                    <option value="Sabado">Sabado</option>
                                                    <option value="Domingo">Domingo</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className='dia-de'>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold"
                                            }}>De:</p>
                                            <div className='custom-select'>
                                                <select id="De" name="De" style={{
                                                    fontFamily: fontType.text
                                                }}
                                                    value={variables.newClass.dias_clase[i].de}
                                                    onChange={e => {
                                                        variables.newClass.dias_clase[i].de = e.target.value

                                                        // Calcular hora fin si hay duración seleccionada
                                                        if (variables.newClass.dias_clase[i].duracion && e.target.value) {
                                                            // Parsear la hora de inicio (formato "HH:MM")
                                                            const [horasInicio, minutosInicio] = e.target.value.split(':').map(Number)
                                                            const duracion = parseFloat(variables.newClass.dias_clase[i].duracion)

                                                            // Convertir todo a minutos para hacer la suma
                                                            const minutosInicioTotal = (horasInicio * 60) + minutosInicio
                                                            const minutosAgregar = duracion * 60
                                                            const minutosFinTotal = minutosInicioTotal + minutosAgregar

                                                            // Convertir de vuelta a horas y minutos
                                                            const horaFinNum = Math.floor(minutosFinTotal / 60)
                                                            const minutosFin = minutosFinTotal % 60

                                                            // Formatear la hora de fin
                                                            const horaFinStr = `${horaFinNum.toString().padStart(2, '0')}:${minutosFin.toString().padStart(2, '0')}`
                                                            variables.newClass.dias_clase[i].a = horaFinStr
                                                        }

                                                        setVariables(prev => ({
                                                            ...prev
                                                        }))
                                                    }}
                                                >
                                                    <option value={""}>...</option>
                                                    {
                                                        hours.map((v) => {
                                                            return (
                                                                <option value={v}>{v}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>

                                        <div className='dia-duracion'>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold"
                                            }}>Duración:</p>
                                            <div className='custom-select'>
                                                <select id="Duracion" name="Duracion" style={{
                                                    fontFamily: fontType.text
                                                }}
                                                    value={variables.newClass.dias_clase[i].duracion}
                                                    onChange={e => {
                                                        variables.newClass.dias_clase[i].duracion = e.target.value

                                                        // Calcular hora fin si hay hora inicio seleccionada
                                                        if (variables.newClass.dias_clase[i].de && e.target.value) {
                                                            // Parsear la hora de inicio (formato "HH:MM")
                                                            const [horasInicio, minutosInicio] = variables.newClass.dias_clase[i].de.split(':').map(Number)
                                                            const duracion = parseFloat(e.target.value)

                                                            // Convertir todo a minutos para hacer la suma
                                                            const minutosInicioTotal = (horasInicio * 60) + minutosInicio
                                                            const minutosAgregar = duracion * 60
                                                            const minutosFinTotal = minutosInicioTotal + minutosAgregar

                                                            // Convertir de vuelta a horas y minutos
                                                            const horaFinNum = Math.floor(minutosFinTotal / 60)
                                                            const minutosFin = minutosFinTotal % 60

                                                            // Formatear la hora de fin
                                                            const horaFinStr = `${horaFinNum.toString().padStart(2, '0')}:${minutosFin.toString().padStart(2, '0')}`
                                                            variables.newClass.dias_clase[i].a = horaFinStr
                                                        }
                                                        
                                                        setVariables(prev => ({
                                                            ...prev
                                                        }))
                                                    }}
                                                >
                                                    <option value={""}>...</option>
                                                    <option value="1">1 Hora</option>
                                                    <option value="1.5">1 Hora 30 Min</option>
                                                    <option value="2">2 Horas</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className='dia-a'>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold"
                                            }}>A:</p>
                                            {variables.newClass.dias_clase[i].a && typeof variables.newClass.dias_clase[i].a === 'string' && variables.newClass.dias_clase[i].a.includes(":") ? (
                                                <input
                                                    type="text"
                                                    style={{
                                                        fontFamily: fontType.text,
                                                        borderColor: "#DDD",
                                                        borderWidth: 2,
                                                        borderStyle: "solid",
                                                        borderRadius: 5,
                                                        padding: 8,
                                                        width: "100%",
                                                        outline: "none"
                                                    }}
                                                    value={variables.newClass.dias_clase[i].a}
                                                    placeholder="Ej: 10:30"
                                                    onChange={e => {
                                                        variables.newClass.dias_clase[i].a = e.target.value
                                                        setVariables(prev => ({
                                                            ...prev
                                                        }))
                                                    }}
                                                />
                                            ) : (
                                                <div className='custom-select'>
                                                    <select id="A" name="A" style={{
                                                        fontFamily: fontType.text
                                                    }}
                                                        value={variables.newClass.dias_clase[i].a}
                                                        onChange={e => {
                                                            variables.newClass.dias_clase[i].a = e.target.value
                                                            setVariables(prev => ({
                                                                ...prev
                                                            }))
                                                        }}
                                                    >
                                                        <option value={""}>...</option>
                                                        {
                                                            hours.map((v) => {
                                                                return (
                                                                    <option value={v}>{v}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className='dia-agregar'>
                        <button style={{
                            backgroundColor: main,
                            fontFamily: fontType.subTitle
                        }} onClick={() => {
                            variables.newClass.dias_clase.push({
                                dia: "",
                                de: "",
                                a: "",
                                duracion: ""
                            })
                            setVariables(prev => ({
                                ...prev
                            }))
                        }}>AGREGAR DIA</button>
                    </div>

                    <p style={{
                        fontFamily: fontType.title,
                        fontWeight: "bold",
                        fontSize: 25,
                        marginBottom: 10
                    }}>JUGADORES</p>

                    {
                        variables.newPlayers.map((v, i) => {
                            return (
                                <div className='player' style={{
                                    width: "50%",
                                    maxWidth: 400,
                                    minWidth: 300,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    flexDirection: "row",
                                    padding: 20,
                                    borderRadius: 10,
                                    border: "2px solid black"
                                }}>
                                    <div style={{
                                        fontFamily: fontType.text,
                                        fontWeight: "bold",
                                        width: "90%",
                                        height: "100%",
                                        flex: 9,
                                        display: "flex",
                                        alignItems: "center",
                                        color: "black",
                                        textDecoration: "none"
                                    }}>{v.nombre_jugador}</div>
                                    <IoMdClose id='outplayer' size={20} color='#C00' onClick={() => {
                                        variables.newPlayers.splice(i, 1)
                                        setVariables(prev => ({
                                            ...prev
                                        }))
                                    }} style={{
                                        height: 25,
                                        flex: 1,
                                        cursor: "pointer"
                                    }} />
                                </div>
                            )
                        })
                    }

                    <div className='dia-agregar'>
                        <button style={{
                            backgroundColor: "black",
                            fontFamily: fontType.subTitle
                        }} onClick={() => {
                            setShowModal(true)
                        }}>AGREGAR JUGADORES</button>
                    </div>

                    <button className='saveclass' onClick={validateFields} style={{
                        marginBottom: 100,
                        marginTop: 30,
                        backgroundColor: main,
                        width: "70%",
                        height: 50,
                        border: "none",
                        borderRadius: 10,
                        cursor: "pointer",
                        maxWidth: 800
                    }}>
                        <p style={{
                            fontSize: 25,
                            fontFamily: fontType.title,
                            color: "white"
                        }}>GUARDAR</p>
                    </button>

                </div>

            </div>

        </div>
    )
}

export default AddClass